import { useNavigate } from 'react-router-dom';
import { useFaq, useFaqQuestions } from '../../lib/faq';

/**
 * フォームの最終画面・送信後の画面に置く、あおいへの入口。
 * 承認済みの「よくある質問」があればカテゴリのタイル（押すとそのカテゴリを開いた案内へ）、無ければ質問ボタン。
 */
export default function FaqEntry({ garden, accent }: { garden: string; accent?: string }) {
  const navigate = useNavigate();
  const faq = useFaq(garden);
  const qs = useFaqQuestions(garden, 4);
  return (
    <div>
      <div className="flex items-center gap-3 mb-3">
        <img src="/images/aoi.jpg" alt="あおい" className="w-12 h-12 rounded-full object-cover object-top border-2 border-white shadow flex-shrink-0 bg-white" />
        <p className="text-base font-bold text-gray-800">こんなこと、あおいに聞けますよ！</p>
      </div>
      {faq.groups.length > 0 ? (
        <div className="grid grid-cols-2 gap-2">
          {faq.groups.slice(0, 6).map((g) => (
            <button key={g.key} type="button" onClick={() => navigate(`/chat?cat=${encodeURIComponent(g.key)}`)}
              className="flex items-center gap-2 bg-white border-2 border-gray-200 rounded-2xl px-3 py-3 text-left active:scale-[0.98] transition-transform cursor-pointer">
              <i className={`${g.icon} text-2xl flex-shrink-0`} style={{ color: accent || 'var(--theme-500)' }}></i>
              <span className="text-sm font-bold text-gray-800 leading-snug">{g.label}</span>
            </button>
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {qs.map((q) => (
            <button key={q} type="button" onClick={() => navigate(`/chat?q=${encodeURIComponent(q)}`)}
              className="w-full text-left text-base text-gray-800 bg-white border-2 border-gray-200 rounded-2xl px-4 py-3 active:scale-[0.99] transition-transform cursor-pointer">{q}</button>
          ))}
        </div>
      )}
      <button type="button" onClick={() => navigate('/chat')} className="mt-2 w-full text-center text-base font-bold text-gray-500 py-2 cursor-pointer">ほかのことを聞く</button>
    </div>
  );
}
